import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'app-information-box',
  templateUrl: './information-box.component.html',
  styleUrls: ['./information-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardComponent, TranslatePipe]
})
export class InformationBoxComponent {
  readonly title = input('');
}
